import type { BadgeOverrideToken } from './types'

const Badge: BadgeOverrideToken = {
  colorText: 'inherit'
} as const

export default Badge
